define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "../../themes"], function (_exports, _objectWithoutPropertiesLoose2, _taggedTemplateLiteralLoose2, _react, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Container = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["children"];

  var _templateObject, _templateObject2, _templateObject3, _templateObject4;

  var ContainerStyled = (0, _styledComponents.default)('div').withConfig({
    displayName: "Container__ContainerStyled",
    componentId: "sc-4944b9-0"
  })(["display:", ";margin-left:auto;margin-right:auto;padding:0 16px;width:100%;", " ", " ", " ", ""], function (_ref) {
    var flex = _ref.flex;
    return flex && 'flex';
  }, _themes.device.tablet(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0;\n    width: 46rem;\n  "]))), _themes.device.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 94vw;\n  "]))), _themes.device.largeDesktop(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-width: 1300px;\n    padding: 0;\n    width: 90vw;\n  "]))), _themes.device.xlargeDesktop(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-width: 1300px;\n    padding: 0;\n    width: 82vw;\n  "]))));

  var Container = function Container(_ref2) {
    var children = _ref2.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded);
    return /*#__PURE__*/_react.default.createElement(ContainerStyled, props, children);
  };

  _exports.Container = Container;
  Container.defaultProps = {
    rounded: true,
    flex: false
  };
});